import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Lines, FadeUp } from "../site/Reveal";
import { SectionLabel } from "../site/Btn";
import { useLang } from "../../i18n/lang";
import { useSiteImages } from "../../lib/siteImages";

export const Objects = () => {
  const { t, to } = useLang();
  const [active, setActive] = useState(0);
  const img = useSiteImages();
  const objImg = (i) => img(`obj_${i + 1}`);
  return (
    <section className="px-6 sm:px-10 lg:px-14 py-28 sm:py-36 lg:py-44" data-testid="objects-section">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 lg:mb-20">
        <div className="lg:col-span-7">
          <SectionLabel n={4}>{t.objects.label}</SectionLabel>
          <Lines lines={[t.objects.title]} className="f-serif font-light tracking-[-0.02em] leading-[1] text-5xl sm:text-6xl lg:text-7xl mt-10" />
        </div>
        <FadeUp className="lg:col-span-4 lg:col-start-9 lg:pt-20">
          <p className="text-base leading-[1.75] text-[#3A3A3A]">{t.objects.text}</p>
        </FadeUp>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <ul className="lg:col-span-6 border-t border-[#1A1A1A]/15">
          {t.objects.items.map((name, i) => (
            <li key={name} className="border-b border-[#1A1A1A]/15">
              <Link to={to("/bespoke-objects")} onMouseEnter={() => setActive(i)} onFocus={() => setActive(i)} data-testid={`object-cat-${i}`}
                className="group flex items-center gap-6 py-6 sm:py-7">
                <span className="f-mono text-xs text-[#555555] w-8">0{i + 1}</span>
                <span className={`f-serif font-light text-3xl sm:text-4xl lg:text-5xl transition-[transform,color] duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] ${active === i ? "lg:translate-x-4 text-[#1A1A1A]" : "lg:text-[#8C8C8C]"}`}>{name}</span>
                {objImg(i) ? <img src={objImg(i)} alt="" loading="lazy" className="lg:hidden ml-auto w-20 h-24 object-cover" /> : <span className="lg:hidden ml-auto w-20 h-24 bg-[#F0F0F0]" />}
              </Link>
            </li>
          ))}
        </ul>
        <div className="hidden lg:block lg:col-span-5 lg:col-start-8">
          <div className="sticky top-28 aspect-[4/5] overflow-hidden bg-[#F0F0F0]">
            <AnimatePresence initial={false}>
              {objImg(active) && <motion.img key={active} src={objImg(active)} alt={t.objects.items[active]}
                className="absolute inset-0 w-full h-full object-cover"
                initial={{ clipPath: "inset(100% 0 0 0)", scale: 1.1 }} animate={{ clipPath: "inset(0% 0 0 0)", scale: 1 }} exit={{ opacity: 0 }}
                transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1] }} />}
            </AnimatePresence>
            <span className="absolute bottom-4 left-4 eyebrow !text-[0.62rem] bg-[#FFFFFF] px-2 py-1">{t.common.inspiration}</span>
          </div>
        </div>
      </div>
    </section>
  );
};
